import { Component, Input, OnInit, ViewChildren } from '@angular/core';
import { UntypedFormArray } from '@angular/forms';
import { PrFormAbstract } from '@app/components/pr-form/pr-form.abstract';
import { PrFormConstructor } from '@app/components/pr-form/pr-form.contructor';
import { EstateDao } from '@app/dao/estate/estate.dao';
import { ReferenceDao } from '@app/dao/reference/reference.dao';
import { UserDao } from '@app/dao/user/user.dao';
import * as _ from 'lodash';
import { combineLatest, Subject } from 'rxjs';
import { EaFeesFormComponent } from '../ea-fees-form/ea-fees-form.component';
import { EaRealestateFormService } from './ea-realestate-form.service';
import { PlaceSearchResult } from '@app/components/pr-form/pr-input-map/pr-input-map.component';

@Component({
    selector: 'ea-realestate-form',
    templateUrl: './ea-realestate-form.component.html',
    styleUrls: ['./ea-realestate-form.component.scss'],
    standalone: false
})
export class EaRealestateFormComponent
  extends PrFormAbstract
  implements OnInit
{
  @Input() parentForm: any;
  @Input() isGMaps: boolean = true;
  users: any[];
  countries: any[] = [];
  personalUseType: any[] = [];
  subscriptionSource: any[] = [];
  doneSubject: Subject<void> = new Subject<void>();
  @ViewChildren(EaFeesFormComponent) feesFormsComponents: EaFeesFormComponent;
  toValue: PlaceSearchResult = { address: '' };

  constructor(
    protected formConstructor: PrFormConstructor,
    private userDao: UserDao,
    private estateDao: EstateDao,
    private referenceDao: ReferenceDao,
    private eaRealestateFormService: EaRealestateFormService,
  ) {
    super(formConstructor);

    this.eaRealestateFormService.generateSubject.subscribe(
      formGroup => (this.form = formGroup),
    );
  }

  ngOnInit() {
    combineLatest([
      this.userDao.getCouple(),
      this.referenceDao.getCountries(),
      this.referenceDao.getPersonalUseType(),
      this.referenceDao.getSubscriptionSource(),
    ]).subscribe(([users, countries, personalUseType, subscriptionSource]) => {
      this.users = users;
      this.countries = countries;
      this.personalUseType = personalUseType;
      this.subscriptionSource = subscriptionSource;
    });

    if (this.parentForm) {
      this.parentForm
        .get('personalUseType')
        .valueChanges.subscribe(value =>
          this.form
            .get('subscriptionSource')
            .setValue(
              value == 'RESIDENCE_PRINCIP'
                ? 'DIRECT'
                : this.entity.subscriptionSource,
            ),
        );
    }
  }

  onSubmit() {
    let formDTOExtraction = _.merge(this.entity, this.extract());
    this.estateDao.postEstate(formDTOExtraction).subscribe(
      success => {
        this.prFormService.loaded();
        this.doneSubject.next();
        this.notificationService.success('La sauvegarde a réussi');
      },
      errors => {
        console.error(errors);
        this.prFormService.loaded();
        this.notificationService.error('La sauvegarde a échoué');
      },
    );
  }

  public generate = () => this.eaRealestateFormService.generate(this.entity);
  public extract = () => this.eaRealestateFormService.extract(this.form);

  get fees() {
    return this.form.get('fees') as UntypedFormArray;
  }
}
